<div class="grid-wrapper" kbStickyAnchorContainer>
    <div class="image">
        <kb-asset-gallery
            class="block"
            kbStickyAnchor
            [assets]="allAssets ?? []"
            [selectedAssetId]="selectedAssetId"
            [videoUrls]="product?.customFields?.videoUrls"
            [productName]="productPreview?.name"
        ></kb-asset-gallery>
    </div>
    <div class="title">
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
            {{ productPreview?.name }}
        </h1>
        <div class="font-medium text-sm text-gray-500" *ngIf="selectedVariant()">
            SKU: {{ selectedVariant()?.sku }}
        </div>
        <kb-brand-label [product]="product"></kb-brand-label>
        <div class="flex md:block">
            <kb-star-rating
                [rating]="productPreview?.customFields?.reviewRating || 0"
                [reviewCount]="productPreview?.customFields?.reviewCount || 0"
                reviewCountAnchor="reviews"
                class="block mb-4"
            ></kb-star-rating>
        </div>
    </div>
    <div class="key-features">
        <div>
            <div>
                <kb-variant-selector-default
                    class=""
                    [product]="product"
                    (addToCartClick)="addToCartClick.emit($event)"
                    (updateOrderLineClick)="updateOrderLineClick.emit($event)"
                    (addToWishlistClick)="addToWishlistClick.emit($event)"
                    (selectedVariantChange)="setSelectedVariant($event)"
                ></kb-variant-selector-default>
                <kb-offer-label [product]="product"></kb-offer-label>
                <kb-product-accordion class="block my-4"
                                      [variants]="product?.variants"
                                      [selectedVariantId]="selectedVariant()?.id"
                                      [keyFeatures]="inlineKeyFeatures ?? tabbedKeyFeatures"
                                      [description]="productPreview.description"
                                      [facetValues]="product?.facetValues"
                />
            </div>
        </div>
    </div>
</div>
